import { useEffect, useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { logout } from '../../utils/functions';
import Breadcrumbs from "./Breadcrumbs"
import {PageTreeContext} from "../../context/pageTreeContext"
import {KOMPASS_SVG_URL, LEHGU_LOGO_URL, INHALTINFO_SVG_URL, TECHNISCHEINFO_SVG_URL, LERNEINHEITEN_SVG_URL, LOGOUT_SVG_URL, BOOKMARK_SVG} from "../../constants"
import { typography } from "@material-tailwind/react";

export default function Navbar({toggleSidebar, isSidebarOPen}){
    const navigate = useNavigate();
    const pageTreeContextValue = useContext(PageTreeContext);
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [kompassDisabled, setKompassDisabled] = useState(false)

    useEffect(() => {
        pageTreeContextValue.amILoggedIn()
        setIsLoggedIn(pageTreeContextValue.loggedIn)
        if(typeof(pageTreeContextValue.pageNavigationInfo) === "undefined"){
            setKompassDisabled(true)
        } else {
            setKompassDisabled(false)
        }
    }, [])

    useEffect(() => {
        setIsLoggedIn(pageTreeContextValue.loggedIn)
    }, [pageTreeContextValue.loggedIn])

    useEffect(() => {
            if(typeof(pageTreeContextValue.pageNavigationInfo) === "undefined"){
                setKompassDisabled(true)
            } else {
                setKompassDisabled(false)
            }
        }, [pageTreeContextValue.pageNavigationInfo])


    const clickLogoutHandler = () => {
        logout()
        navigate("/")
    }




    return (
        <div className="navbarWrapper">
            <div className="navbar mt-3 mb-3 navbarWrapper-inner">
                <div className="navButtons-container navButtons-container-upper">

                    <div className="tooltipTarget navbar-icon-margin">
                        <img className="navbar-logo " src={LEHGU_LOGO_URL} 
                            width="240" 
                            onClick={() => {navigate('/start')}} alt=""                             
                        /> 
                        <span className="tooltipText tooltipTextLogo">Übersicht</span>
                    </div>

                    


                    {isLoggedIn && 
                    <div className="introButtonsWrapper ">
                        <div class="tooltipTarget navbar-icon-margin">
                            <img src={INHALTINFO_SVG_URL} 
                                    width="70" onClick={() => {navigate('/inhaltliche-einfuehrung')}} alt=""   
                                /> 
                            <span className="tooltipText">Inhaltliche Einführung</span>
                        </div>
                        <div className="tooltipTarget navbar-icon-margin">
                            <img className="navbar-icon-margin" 
                                src={TECHNISCHEINFO_SVG_URL} 
                                width="70" onClick={() => {navigate('/technische-einfuehung')}} alt=""  
                            /> 
                            <span className="tooltipText">Technische Einführung</span>
                        </div>
                        <div className="tooltipTarget navbar-icon-margin">
                            <img className="navbar-icon-margin" 
                                src={BOOKMARK_SVG} 
                                width="70" onClick={() => {navigate('/favorites/pages')}} alt=""  
                            /> 
                            <span className="tooltipText">Lesezeichen</span>
                        </div>

                    </div>
                    }
                </div>
                <div className="navButtons-container ">
                    {isLoggedIn && 
                    <div className="navButtons-container-lower ">
                        <div class="tooltipTarget navbar-icon-margin">
                            <img src={KOMPASS_SVG_URL} 
                                className={kompassDisabled ? "navbar-kompass-disabled" : "navbar-kompass "} 
                                width="70" onClick={() => {
                                    if(!kompassDisabled){
                                        toggleSidebar()
                                    }}} alt="" 
                            /> 
                            <span className="tooltipText">Navigation</span>
                        </div>
                        <div class="tooltipTarget navbar-icon-margin">
                            <img className="navbar-icon-margin" 
                                src={LERNEINHEITEN_SVG_URL} 
                                width="70" onClick={() => {navigate('/lerneinheiten')}} alt="" 
                            />  
                            <span className="tooltipText">Lerneinheiten</span>
                        </div>
                        <div className="tooltipTarget navbar-icon-margin">
                            <img className="navbar-icon-margin" src={LOGOUT_SVG_URL} 
                                width="70" onClick={clickLogoutHandler} alt="" 
                            /> 
                            <span className="tooltipText">Logout</span>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div className=' '>
                <Breadcrumbs />
            </div>
                    
        </div>
    )
}


//TODO: url and height/width to constant
            	